module.exports = __webpack_public_path__ + "img/granstra.f054272a.svg";